import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const defaultOptions = {
    position: 'bottom-right',
    theme: 'colored',
};
const createToast = (type) => (message, options) => {
    switch (type) {
        case 'success':
            toast.success(message, Object.assign(Object.assign({}, defaultOptions), options));
            break;
        case 'error':
            toast.error(message, Object.assign(Object.assign({}, defaultOptions), options));
            break;
        case 'info':
            toast.info(message, Object.assign(Object.assign({}, defaultOptions), options));
            break;
        case 'warning':
            toast.warning(message, Object.assign(Object.assign({}, defaultOptions), options));
            break;
    }
};
/**
 * Toast表示
 *
 * root.tsxでreact-toastifyのToastContainerの設定が必要です
 *
 * https://www.npmjs.com/package/react-toastify
 *
 * @example
 * ```tsx
 * showToast.success('成功しました')
 * ```
 *
 * @example
 * ```tsx:root.tsx
 * <ToastContainer />
 * ```
 */
const showToast = {
    success: createToast('success'),
    error: createToast('error'),
    info: createToast('info'),
    warning: createToast('warning'),
};
export default showToast;
//# sourceMappingURL=showToast.js.map